{
  "FormEnginePageElement": {
    "title": "Buchseite"
  },
  "mask": {
    "FormEnginePageElement": {
      "groupTitle": "Buchseite",
      "isDefault": "Als Einstiegsseite verwenden"
    }
  }
}